<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.note' | translate"
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    <nz-form-item>
      <nz-form-control>
        <textarea rows="4" nz-input [formControl]="notesFormControl"></textarea>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
